import { useMemo } from 'react';
import type { LegacyMilestone } from '../data/legacyMilestones';
import { useTimelineYears } from './useTimelineYears';

type LegacyTimelineViewModel = {
  contextTitle: string;
  contextSubtitle: string;
  timelineYearsHeading: string;
  timelineYearsSubheading: string;
  instanceId: string;
  timelineYears: ReturnType<typeof useTimelineYears>;
};

export const useLegacyTimelineViewModel = (
  milestones: LegacyMilestone[],
  activeMilestone: LegacyMilestone,
  activePhotoIndex: number
): LegacyTimelineViewModel => {
  const timelineYears = useTimelineYears(milestones, activeMilestone.year, activePhotoIndex);

  return useMemo(
    () => ({
      contextTitle: `${activeMilestone.year} • ${activeMilestone.title}`,
      contextSubtitle: activeMilestone.locations,
      timelineYearsHeading: 'Program Timeline',
      timelineYearsSubheading: activeMilestone.title,
      instanceId: activeMilestone.year,
      timelineYears,
    }),
    [activeMilestone, timelineYears]
  );
};
